let BConfig = {
    "breakpoints": [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    "formControls": {
        "size": null
    },
    "BAlert": {
        "dismissLabel": "Close",
        "variant": "info"
    },
    "BAvatar": {
        "variant": "primary"
    },
    "BBadge": {
        "variant": "primary"
    },
    "BButton": {
        "size": null,
        "variant": "primary"
    },
    "BButtonClose": {
        "content": "&times;",
        "textVariant": null,
        "ariaLabel": "Close"
    },
    "BCalendar": {
        "labelPrevDecade": "Previous decade",
        "labelPrevYear": "Previous year",
        "labelPrevMonth": "Previous month",
        "labelCurrentMonth": "Current month",
        "labelNextMonth": "Next month",
        "labelNextYear": "Next year",
        "labelNextDecade": "Next decade",
        "labelToday": "Today",
        "labelSelected": "Selected date",
        "labelNoDateSelected": "No date selected",
        "labelCalendar": "Calendar",
        "labelNav": "Calendar navigation",
        "labelHelp": "Use cursor keys to navigate calendar dates"
    },
    "BCardSubTitle": {
        "subTitleTextVariant": "muted"
    },
    "BCarousel": {
        "labelPrev": "Previous Slide",
        "labelNext": "Next Slide",
        "labelGotoSlide": "Goto Slide",
        "labelIndicators": "Select a slide to display"
    },
    "BDropdown": {
        "toggleText": "Toggle Dropdown",
        "size": null,
        "variant": "primary",
        "splitVariant": "moreDarkPrimary"
    },
    "BFormDatepicker": {
        "labelPrevDecade": null,
        "labelPrevYear": null,
        "labelPrevMonth": null,
        "labelCurrentMonth": null,
        "labelNextMonth": null,
        "labelNextYear": null,
        "labelNextDecade": null,
        "labelToday": null,
        "labelSelected": null,
        "labelNoDateSelected": null,
        "labelCalendar": null,
        "labelNav": null,
        "labelHelp": null,
        "labelTodayButton": "Select today",
        "labelResetButton": "Reset",
        "labelCloseButton": "Close"
    },
    "BFormFile": {
        "browseText": "Browse",
        "placeholder": "No file chosen",
        "dropPlaceholder": "Drop files here"
    },
    "BFormTag": {
        "removeLabel": "Remove tag",
        "variant": "primary"
    },
    "BFormTags": {
        "addButtonText": "Add",
        "addButtonVariant": "outline-primary",
        "duplicateTagText": "Duplicate tag(s)",
        "invalidTagText": "Invalid tag(s)",
        "placeholder": "Add tag...",
        "tagRemoveLabel": "Remove tag",
        "tagRemovedLabel": "Tag removed",
        "tagVariant": "primary"
    },
    "BFormText": {
        "textVariant": "muted"
    },
    "BFormTimepicker": {
        "labelNoTimeSelected": null,
        "labelSelected": null,
        "labelHours": null,
        "labelMinutes": null,
        "labelSeconds": null,
        "labelAmpm": null,
        "labelAm": null,
        "labelPm": null,
        "labelDecrement": null,
        "labelIncrement": null,
        "labelNowButton": "Select now",
        "labelResetButton": "Reset",
        "labelCloseButton": "Close"
    },
    "BFormSpinbutton": {
        "labelDecrement": "Decrement",
        "labelIncrement": "Increment"
    },
    "BImg": {
        "blankColor": "transparent"
    },
    "BImgLazy": {
        "blankColor": "transparent"
    },
    "BInputGroup": {
        "size": null
    },
    "BJumbotron": {
        "bgVariant": null,
        "borderVariant": null,
        "textVariant": null
    },
    "BListGroupItem": {
        "variant": null
    },
    "BModal": {
        "titleTag": "h5",
        "size": "md",
        "headerBgVariant": null,
        "headerBorderVariant": null,
        "headerTextVariant": null,
        "headerCloseVariant": null,
        "bodyBgVariant": null,
        "bodyTextVariant": null,
        "footerBgVariant": null,
        "footerBorderVariant": null,
        "footerTextVariant": null,
        "cancelTitle": "Cancel",
        "cancelVariant": "primary",
        "okTitle": "OK",
        "okVariant": "primary",
        "headerCloseContent": "&times;",
        "headerCloseLabel": "Close"
    },
    "BNavbar": {
        "variant": null
    },
    "BNavbarToggle": {
        "label": "Toggle navigation"
    },
    "BPagination": {
        "size": null
    },
    "BPaginationNav": {
        "size": null
    },
    "BPopover": {
        "boundary": "scrollParent",
        "boundaryPadding": 5,
        "customClass": null,
        "delay": 50,
        "variant": null
    },
    "BProgress": {
        "variant": null
    },
    "BProgressBar": {
        "variant": null
    },
    "BSpinner": {
        "variant": null
    },
    "BSidebar": {
        "bgVariant": "light",
        "textVariant": "dark",
        "shadow": false,
        "width": null,
        "tag": "div"
    },
    "BTable": {
        "selectedVariant": "active",
        "headVariant": null,
        "footVariant": null
    },
    "BTime": {
        "labelNoTimeSelected": "No time selected",
        "labelSelected": "Selected time",
        "labelHours": "Hours",
        "labelMinutes": "Minutes",
        "labelSeconds": "Seconds",
        "labelAmpm": "AM/PM",
        "labelAm": "AM",
        "labelPm": "PM",
        "labelIncrement": null,
        "labelDecrement": null
    },
    "BToast": {
        "toaster": "b-toaster-top-right",
        "autoHideDelay": 5000,
        "variant": null,
        "toastClass": null,
        "headerClass": null,
        "bodyClass": null
    },
    "BToaster": {
        "ariaLive": null,
        "ariaAtomic": null,
        "role": null
    },
    "BTooltip": {
        "boundary": "scrollParent",
        "boundaryPadding": 5,
        "customClass": null,
        "delay": 50,
        "variant": null
    }
};

export default BConfig;